import {Button} from 'components/system/Button'
import {useContactUsPath} from 'providers/EnvironmentProvider'
import {useCallback} from 'react'

export const Feedback = () => {
  const contactUsPath = useContactUsPath()

  const onClick = useCallback(() => {
    window.location.href = contactUsPath
  }, [contactUsPath])

  return (
    <div className="p-12 flex flex-col bg-[#F1F2F3] rounded-lg">
      <div className="text-[22px] font-bold">Help us improve!</div>
      <div className="mt-2 mb-6">
        We're curious to know how smooth the checkout was for you. Your feedback can help us enhance the experience for
        everyone.
      </div>
      <Button.Primary.Orange onClick={onClick}>Give feedback</Button.Primary.Orange>
    </div>
  )
}
